
import Vue from "vue"
import { uniq } from 'lodash'

const integrations = {
    state: {
        pausedOnboarding: JSON.parse(localStorage.getItem('pausedOnboarding') || '[]'),
        publicAppsOnboarding: null
    },
    actions: {
        pauseOnboarding({commit, getters}) {
            commit('PAUSE_ONBOARDING', {
                project_uuid: getters.getCurrentProject.uuid
            })
        },

        unpauseOnboarding({commit, getters}) {
            commit('UNPAUSE_ONBOARDING', {
                project_uuid: getters.getCurrentProject.uuid
            })
        },

        async fetchPublicAppsOnboarding({state}) {
            const { data } = await this._vm.$http.get("/v3/system/gateway/app-service/public-app/onboarding")
            state.publicAppsOnboarding = data

            return data
        }
        
    },
    mutations: {
        PAUSE_ONBOARDING (state, data) {
            state.pausedOnboarding.push(data)

            const paused = uniq(state.pausedOnboarding)

            localStorage.setItem("pausedOnboarding", JSON.stringify(paused))
        },

        UNPAUSE_ONBOARDING (state, id) {
            state.pausedOnboarding = state.pausedOnboarding.filter(i => {
                return i.id != id && i.project_uuid == state.currentProject
            })

            const paused = uniq(state.pausedOnboarding)

            localStorage.setItem("pausedOnboarding", JSON.stringify(paused))
        },

        UNPAUSE_ONBOARDING_ALL (state) {
            Vue.set(state, 'pausedOnboarding', [])
            localStorage.setItem("pausedOnboarding", JSON.stringify([]))
        },

        INTEGRATION_ONBOARDED (state, id) {
            const items = state.items.map(i => {
                if (i.id == id && type == "integration") {
                    i.onboarded = true
                }

                return i
            })

            Vue.set(state, 'items', items)
        },

        APP_ONBOARDED (state, id) {
            const items = state.items.map(i => {
                if (i.id == id && type == "app") {
                    i.onboarded = true
                }

                return i
            })

            Vue.set(state, 'items', items)
        }
    },
    getters: {
        getPausedOnboardings(state) {
            return state.pausedOnboarding || []
        },

        getOnboardingRequiredIntegrations(state, getters) {
            return getters.getIntegrations.filter(i => {
                return i.onboarded !== null && !i.onboarded
            })
        },

        getOnboardingRequiredPlatformApps(state, getters) {
            return getters.getApps.filter(app => {
                return app.onboarding.required && !app.onboarding.finished
            })
        },

        getOnboardingRequiredPublicApps(state) {
            return state.publicAppsOnboarding
        }
    }
  }

export default integrations